$(document).ready(function () {
  //==========================================================================================Document-Start

  //=======================================Product / Video-play-pause
  $(".video_play").click(function () {
    $(".video_bann").get(0).play();
    $(".video_play").css("opacity", "0");
  });
  $(".video_bann").click(function () {
    $(".video_bann").get(0).pause();
    $(".video_play").css("opacity", "1");
  });
  //=======================================Product / hover-active-class
  $(".item_heighlight_box").hover(function () {
    $(".item_heighlight_box").removeClass("active");
    $(this).addClass("active");
  });
  //========================================Product / info-slider
  var slider = new Swiper(".mySwiper2.product_info_mainimg", {
    slidesPerView: 1,
    loop: true,
    allowTouchMove: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
  var thumbs = new Swiper(".mySwiper.product_info_thumbnail", {
    loop: true,
    spaceBetween: 0,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  slider.controller.control = thumbs;
  thumbs.controller.control = slider;
}); //===================================================================================================================Document-End

// $(document).ready(function() {
//     $(window).on('scroll', function() {
//         var scrollPos = $(window).scrollTop(); // Get current scroll position
//         var cardInnerOffset = $('.card__inner').offset().top; // Get the top offset of .card__inner
//         var cardContentOffset = $('.card__content').offset().top; // Get the position of .card__content
//         var smallDescHeight = $('.card__small_desc').outerHeight(); // Get the height of the sticky element

//         // Check if the user has scrolled past .card__inner but not yet reached .card__content
//         if (scrollPos >= cardInnerOffset && scrollPos + smallDescHeight < cardContentOffset) {
//             $('.card__small_desc').css({
//                 position: 'fixed',  // Make it fixed position while scrolling
//                 zIndex: 1,
//                 top: '10px'  // Keep it a fixed distance from the top
//             });
//         }
//         // Remove the fixed position when the user scrolls past .card__content
//         else if (scrollPos + smallDescHeight >= cardContentOffset) {
//             $('.card__small_desc').css({
//                 position: 'absolute',  // Revert to default absolute positioning
//                 top: (cardContentOffset - cardInnerOffset - smallDescHeight) + 'px' // Position it just before .card__content
//             });
//         }
//         // Remove the fixed position when scrolling above .card__inner
//         else {
//             $('.card__small_desc').css({
//                 position: 'absolute',  // Absolute position before reaching card__inner
//                 top: '10px'  // Reset the top value
//             });
//         }
//     });
// });

// document.addEventListener('DOMContentLoaded', function() {
//   var tagLinks = document.querySelectorAll('.tag-link');
//   var tagDropdown = document.getElementById('tagDropdown');

//   // Function to filter articles
//   function filterArticles(tag) {
//     var articles = document.querySelectorAll('.article');

//     articles.forEach(function(article) {
//       var articleTags = article.getAttribute('data-tags') || ''; // Ensure articleTags is a string
//       if (tag === 'all' || articleTags.includes(tag)) {
//         article.style.display = 'block';
//       } else {
//         article.style.display = 'none';
//       }
//     });
//   }

//   // Event listener for tag links
//   tagLinks.forEach(function(link) {
//     link.addEventListener('click', function(event) {
//       event.preventDefault();

//       var tag = this.getAttribute('data-tag');
//       filterArticles(tag);

//       // Remove 'active' class from all tag links
//       tagLinks.forEach(function(tagLink) {
//         tagLink.classList.remove('active');
//       });

//       // Add 'active' class to the clicked tag link
//       this.classList.add('active');
//     });
//   });

//   // Event listener for tag dropdown
//   tagDropdown.addEventListener('change', function(event) {
//     var selectedTag = this.value;
//     filterArticles(selectedTag);
//   });
// });

//================================ Variant-popup

document.addEventListener("DOMContentLoaded", function () {
  // Get the elements
  const formLabels = document.querySelectorAll(
    ".product-form__input legend.form__label span"
  );
  let currentActivePopup = null; // To keep track of the currently active popup

  formLabels.forEach((span) => {
    span.addEventListener("click", function (event) {
      const variantSelects = event.target.closest("variant-selects");
      const popupId = variantSelects.getAttribute("data-popup-id");
      const productSwatchesPopup = document.getElementById(popupId);

      // Close any currently active popup before opening the new one
      if (currentActivePopup && currentActivePopup !== productSwatchesPopup) {
        currentActivePopup.classList.remove("Product-swatches-popup__active");
      }

      // Toggle the active class for the clicked popup
      productSwatchesPopup.classList.toggle("Product-swatches-popup__active");

      // Update the current active popup
      currentActivePopup = productSwatchesPopup.classList.contains(
        "Product-swatches-popup__active"
      )
        ? productSwatchesPopup
        : null;

      event.stopPropagation(); // Prevent the event from bubbling up to the body

      // Add click event listener to the body to remove the active class
      document.body.addEventListener(
        "click",
        function () {
          if (currentActivePopup) {
            currentActivePopup.classList.remove(
              "Product-swatches-popup__active"
            );
            currentActivePopup = null; // Reset current active popup
          }
        },
        { once: true }
      );

      // Prevent clicks inside .Product-swatches-popup from removing the active class
      productSwatchesPopup.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    });
  });
});

//=============================Mobile-view

$(".Product-swatches-popup-header").click(function () {
  $(".Product-swatches-popup").removeClass("Product-swatches-popup__active");
  $("body").removeClass("popup_class");
});

//=====================data-true
document.addEventListener("DOMContentLoaded", function () {
  const swatches = document.querySelectorAll(".js-product-swatch");

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      // Remove data-selected="true" from previously selected swatch
      const selectedSwatch = document.querySelector(
        '.js-product-swatch[data-selected="true"]'
      );
      if (selectedSwatch) {
        selectedSwatch.removeAttribute("data-selected");
      }

      // Add data-selected="true" to the clicked swatch
      this.setAttribute("data-selected", "true");
    });
  });
});

//======================Value-change

var swatches = document.querySelectorAll(".js-product-swatch");

swatches.forEach(function (swatch) {
  swatch.addEventListener("click", function () {
    // Remove data-selected attribute from all swatches
    swatches.forEach(function (item) {
      item.removeAttribute("data-selected");
    });

    // Add data-selected attribute to the clicked swatch
    var productTitle = this.getAttribute("data-product-title");
    this.setAttribute("data-selected", "true");

    // Optionally, you can log the product title to verify
    console.log("Selected Product:", productTitle);

    var labelSpan = document.querySelector(
      ".product-form__input--swatch .form__label span"
    );

    // Check if the labelSpan exists
    if (labelSpan) {
      // Print the selected value into the span
      labelSpan.textContent = productTitle;
    }
  });
});

// remove a tag ni custom product slider================

// $(window)
//   .on("resize", function () {
//     if ($(window).width() <= 1399) {
//       $(".card__information a").removeAttr("href");
//     } else {
//       $(".card__information a").attr("href", "#");
//     }
//   })
//   .trigger("resize");
